


























































import { defineComponent, reactive, SetupContext } from '@vue/composition-api';

interface State {
  items: string[];
  editing: string | null;
  editingIndex: number;
  search: string | null;
}

interface Props {
  items: string[];
  editLogoPlacement: (newLogoPlacements: string[]) => {};
}

const Component = defineComponent({
  name: 'LogoPlacementComponent',

  props: {
    items: [],
    editLogoPlacement: Function,
  },

  setup(props: Props, {}: SetupContext) {
    const state = reactive({
      items: props.items,
      editing: null,
      editingIndex: -1,
      search: null,
    }) as State;

    function edit(index: number, item: any) {
      if (!state.editing) {
        state.editing = item;
        state.editingIndex = index;
      } else {
        state.editing = null;
        state.editingIndex = -1;
      }
    }

    function filter(item: any, queryText: string, itemText: string) {
      if (item.header) return false;

      const hasValue = (val: any) => (val != null ? val : '');

      const text = hasValue(itemText);
      const query = hasValue(queryText);

      return (
        text
          .toString()
          .toLowerCase()
          .indexOf(query.toString().toLowerCase()) > -1
      );
    }

    return {
      state,
      edit,
      filter,
    };
  },
});
export default Component;
